module.exports = __webpack_public_path__ + "img/pc6.486b7cb4.png";